'use client';

import type { ModalProps } from '../components';
import { CircleCloseButton, ModalBase } from '../components';
import styles from './simple-modal.component.module.scss';

type Props = Omit<ModalProps, 'isOpen'> & {
  /**
   * aria-labelを指定します
   * ※ModalPropsはオプショナルのため必須にする
   */
  contentLabel: string;
  /**
   * モーダルが開いているかどうかを指定します
   */
  isOpen?: boolean;
  /**
   * モーダルの閉じるボタンを自動フォーカスするかどうかを指定します
   */
  autoFocusCloseButton?: boolean;
};

/**
 * 閉じるボタンとコンテンツを持つ、シンプルなモーダルコンポーネントです。
 * 固定スタイルは閉じるボタン、幅、パディングのみで、コンテンツは自由に指定できます。
 */
export const SimpleModal = ({
  className,
  isOpen = false,
  autoFocusCloseButton = false,
  ...rest
}: Props) => {
  return (
    <ModalBase
      className={[className, styles.container].filter(Boolean).join(' ')}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      {...rest}
    >
      <CircleCloseButton
        aria-label="閉じる"
        autoFocus={autoFocusCloseButton}
        type="button"
        onClick={rest.onRequestClose}
      />
      <div className={styles.content}>{rest.children}</div>
    </ModalBase>
  );
};
